import { useCallback, useEffect, useReducer } from 'react'
import { get } from 'lodash'
import { getActiveForms } from '../api'

const SET_TYPES = 'SET_TYPES'
const SET_ACTIVE_TYPE = 'SET_ACTIVE_TYPE'
const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP'

const initialState = {
  types: [],
  activeType: null,
  activeStep: 0
}

const reducer = (state, action) => {
  const { type, payload } = action

  switch (type) {
    case SET_TYPES: {
      const { types } = payload
      const activeType = get(types, '[0]')

      return {
        types,
        activeType,
        activeStep: get(activeType, 'steps[0]')
      }
    }
    case SET_ACTIVE_TYPE: {
      const { type } = payload

      return {
        ...state,
        activeType: type,
        activeStep: type.steps[0]
      }
    }
    case SET_ACTIVE_STEP: {
      const { step } = payload

      return {
        ...state,
        activeStep: state.activeType.steps[step]
      }
    }
    default: {
      return state
    }
  }
}

export const useActiveForm = (formTypeName, submitAction) => {
  const [{ types, activeType, activeStep }, dispatch] = useReducer(
    reducer,
    initialState
  )
  const stepsAmount = get(activeType, 'steps.length')

  const getActiveForm = useCallback(() => {
    return getActiveForms({ formType: formTypeName })
      .then((data) => {
        dispatch({ type: SET_TYPES, payload: { types: data } })
      })
      .catch((error) => console.log(error))
  }, [formTypeName])

  useEffect(() => {
    getActiveForm()
  }, [getActiveForm])

  const setActiveType = useCallback((type) => {
    dispatch({ type: SET_ACTIVE_TYPE, payload: { type } })
  }, [])
  const setActiveStep = useCallback((step) => {
    dispatch({ type: SET_ACTIVE_STEP, payload: { step } })
  }, [])
  const submit = useCallback(
    (fields, ...props) => {
      return submitAction({ ...fields, id: activeType.id }, ...props)
    },
    [submitAction, activeType, types]
  )

  return {
    types,
    activeType,
    activeStep,
    stepsAmount,
    setActiveStep,
    setActiveType,
    resetActiveForm: getActiveForm,
    submit
  }
}

export default useActiveForm
